<template>
  <section>
    <div class="md:px-4 pt-2">
      <ul>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span class="text-fg-muted">Wallet Tag</span>
          <span class="flex items-center gap-x-2 text-root-2">
            <span class="capitalize">
              {{ walletTag }}
            </span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span class="text-fg-muted">Asset</span>
          <span class="flex items-center gap-x-2 text-root-2">
            <currency-icons :currency="getCurrencyCountry(assetType)" />
            <span>
              {{ assetType }}
            </span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span class="text-fg-muted">Wallet Address</span>
          <span class="text-root-2">
            {{ maskID(walletAddress) }}
            <span
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="walletAddress"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span class="text-fg-muted">Date Created</span>
          <span class="text-root-2">
            {{ $dayjs(currentWithdrawalDetails.createdAt).format('DD MMM') }},
            {{ parseLocalTime(currentWithdrawalDetails.createdAt) }}
          </span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span class="text-fg-muted">Compliance</span>
          <span
            class="text-xs text-center font-normal rounded-lg px-1 py-2 capitalize w-24 mt-3 mb-2"
            :class="statusClass(currentWithdrawalDetails.complianceStatus)"
          >
            {{ currentWithdrawalDetails.complianceStatus }}
          </span>
        </li>
      </ul>
      <div class="absolute bottom-0 left-0 right-0 w-6/6 mx-5">
        <div
          @click="handleDeleteWithdrawalMethod()"
          class="shadow-lg text-error-default bg-red-100 border-error-default my-4 py-3 px-3 font-normal w-full text-center rounded-md cursor-pointer"
        >
          <span class="flex justify-center gap-x-3 items-center">
            <delete-icon class="h-5 w-5" />
            <span> Delete Account </span>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  GetCurrencyCountry,
  MaskWalletAddressTwo,
  StatusClass,
  ParseLocalTime
} from '@/utils/helpers.js'
export default {
  name: 'Drawer',
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  props: {
    currentWithdrawalDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    DeleteIcon: () => import('@/assets/icons/DeleteIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  computed: {
    walletTag () {
      return (
        this.currentWithdrawalDetails?.details?.walletTag ||
        this.currentWithdrawalDetails?.details?.walletDetails?.walletTag ||
        '-'
      )
    },
    network () {
      return (
        this.currentWithdrawalDetails?.details?.network ||
        this.currentWithdrawalDetails?.details?.walletDetails?.network ||
        '-'
      )
    },
    assetType () {
      return (
        this.currentWithdrawalDetails.details.assetName ||
        this.currentWithdrawalDetails?.details?.walletDetails?.assetType ||
        '-'
      )
    },
    walletAddress () {
      return (
        this.currentWithdrawalDetails?.details?.walletAddress ||
        this.currentWithdrawalDetails?.details?.walletDetails?.walletAddress ||
        '-'
      )
    },
    drawerWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    withdrawalMethods () {
      return this.$store.state.withdrawal.withdrawalMethods
    }
  },
  methods: {
    parseLocalTime (val) {
      return ParseLocalTime(val)
    },
    statusClass (status) {
      return StatusClass(status)
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    toggleShow (arg) {
      this[arg] = !this[arg]
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    handleDeleteWithdrawalMethod () {
      this.$emit('handleDeleteWithdrawalMethod')
    }
  }
}
</script>

<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 1.1rem;
  color: var(--foreground-default);
  font-weight: 600;
}
>>> .el-drawer__header {
  color: var(--foreground-default);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-main);
  margin-bottom: 20px;
}
>>> .el-drawer {
  background: var(--background-canvas) !important;
}
</style>
